import AnimatedList from './animated_list';

export default AnimatedList;
